import React from 'react'
import classnames from 'classnames'
import { Bars } from '../../../../icons'

const showMobileSidebar = () => {
  window.dispatchEvent(new CustomEvent('show-mobile-sidebar', { // eslint-disable-line
    detail: { show: true }
  }))
}

const PageHeaderSidebarTrigger = ({wrapped}) => {
  return (
    <button
      className={classnames(
        'vs-page-header__sidebar-trigger',
        {'vs-page-header__sidebar-trigger--wrapped': wrapped}
      )}
      onClick={showMobileSidebar}>
      <Bars />
    </button>
  )
}

export default PageHeaderSidebarTrigger
